import { jsx as _jsx } from "react/jsx-runtime";
import Input from "../../../form/Input";
const SliderInput = ({ value, onChange, }) => (_jsx(Input, { "data-testid": "slider-input", className: "m-5 w-24 text-center text-black text-opacity-50", type: "number", size: "condensed", value: value, onChange: (e) => onChange(Number.parseFloat(e.target.value)) }));
export default SliderInput;
